export const TableConstants = {
    ROWS_PER_PAGE: 50,
};